//#region header */
/**************************************************************************************************
//
//  Description: Organisation Tree component to display the list of organisations in a tree view.
//
//  Copyright:    © 2025 - 2026 Idox Software Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
//#region Version 1.0.0.0 changes
//    001   12.03.25 Sean Flook          GMSCM-1 Initial Revision.
//    002   05.02.26 Sean Flook         GMSCM-12 Changed to handle arrays.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion header */

import axios, { AxiosInstance } from "axios";
import { getConfigValue } from "../configuration/runtimeEnv";

class SecurityAPIClient<T> {
  endpoint: string;
  userToken?: string;
  private _axiosInstance: AxiosInstance;

  constructor(endpoint: string, userToken?: string) {
    this.endpoint = endpoint;
    this.userToken = userToken;
    const securityApi = getConfigValue("REACT_APP_SECURITY_API", process.env.REACT_APP_SECURITY_API);
    const securityVersion = getConfigValue("REACT_APP_SECURITY_VERSION", process.env.REACT_APP_SECURITY_VERSION);
    const baseURL = `${securityApi}/api/v${securityVersion}`;

    if (userToken) {
      this._axiosInstance = axios.create({
        baseURL: baseURL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.userToken,
        },
      });
    } else {
      this._axiosInstance = axios.create({
        baseURL: baseURL,
        headers: {
          "Content-Type": "application/json",
        },
      });
    }
  }

  getAll = () => {
    return this._axiosInstance.get<T[]>(this.endpoint).then((response) => response.data);
  };

  post = (data: T[]) => {
    return this._axiosInstance.post<T[]>(this.endpoint, data).then((response) => response.data);
  };
}

export default SecurityAPIClient;
